import { render, staticRenderFns } from "./PosterFundamental.vue?vue&type=template&id=c3fb040e&"
import script from "./PosterFundamental.vue?vue&type=script&lang=ts&"
export * from "./PosterFundamental.vue?vue&type=script&lang=ts&"
import style0 from "./PosterFundamental.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports